import React, {useState} from "react";
import * as prosConnect from "../prodect/ProsConnect"
import {
    ATTR_CUSTOMER_ADMIN_EMAILS,
    ROLE_ADMIN, ROLE_INSPECT, ROLE_REPAIR, ROLE_READER, ROLE_NONE,
    prosLogErr, ATTR_OBJ_STATE, OBJ_STATE_ACT, UI_LISTED_ELEMENTS_LIMIT
} from "../prodect/ProsConnect";
import {renderPermissionElement, prosMultiFilterText} from "../prodect/ProsCommonUi";
import LoadingAnimation from "../components/LoadingAnimation";
import {ConfirmButton} from "../components/BasicButton";
import AccordionDropdown from "../components/AccordionDropdown";
import Spacer from "../components/Spacer";
import {TimerTextInput} from "../components/TextInput";

// TODO - show user permissions - show if user is a "customer head master user"
// TODO - remove user permissions - alert or remove users "head master role"

export function CustomerUsers(props) {
    const [users, setUsers] = useState([])
    const [groups, setGroups] = useState([])
    const [projects, setProjects] = useState([])
    const [customer, setCustomer] = useState(undefined)
    const [checkEmail, setCheckEmail] = useState('')
    const [loadingNote, setLoadingNote] = useState('')
    let self = this

    function startLongQueryToGetPermissions() {
        setLoadingNote("Hetkinen - päivitetään käyttöoikeustilanne..")
        prosConnect.startLongQuery(self, prosConnect.QUERY_CUSTOMER_PERMS, props.customerId, refreshPermissions)
    }

    React.useEffect(() => {
        startLongQueryToGetPermissions()
        return function cleanup() {
            prosConnect.stopLongQuery(self)
        }
        // This is needed to avoid unnecessary build warning
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props, self])

    async function refreshPermissions(data) {
        // isFresh parameter in callback is not needed for permissions
        // as server replies only with up-to-date data
        // cache is deleted when permissions have been changed
        setUsers(data.users)
        setGroups(data.groups)
        setProjects(data.projects)
        setLoadingNote('')
        setCustomer(await prosConnect.getCustomerSettings(props.customerId))
        prosConnect.stopLongQuery(self)
    }

    function renderCustomer(){
        if (!customer) {
            return null
        }
        return <div className={"width-50_xxl msg msg-info"}>
            <h3>Pääkäyttäjät</h3>
            <ul>
                {customer[ATTR_CUSTOMER_ADMIN_EMAILS].split(',').map((item)=>{
                    return <li key={"admin__" + item}><p><a href={"mailto:" + item}>{item}</a></p></li>
                })}
            </ul>
        </div>
    }

    function renderUser(user) {
        return <React.Fragment key={user.email}><div>{user.email}</div><div>{user.name}</div></React.Fragment>
    }

    function renderUsers(){
        return <div className={"grid-container grid-flex-2 custom-grid-borders"}>
            {users.map(user => renderUser(user))}
        </div>
    }

    function getUserName(email) {
        let user = users.find(user=> user.email === email)
        return user ? user.name : email
    }

    function renderGroup(group) {
        let note = group.members.length < 1 ? <p>Ryhmässä ei ole käyttäjiä</p> : null
        return <div key={'accordion__' + group.id}>
                <AccordionDropdown header={<h4>{group.name}</h4>}>
                    {note ? note : <div className={"grid-container grid-flex-2 custom-grid-borders"}>
                        {group.members.map((email, i) =>
                            <React.Fragment key={i}>
                                <div>{email}</div><div>{getUserName(email)}</div>
                            </React.Fragment>
                        )}
                    </div>}
                </AccordionDropdown>
            </div>
    }

    function renderGroups(){
        if (groups.length < 1) {
            return <p>Ei käyttöoikeusryhmiä</p>
        }
        return groups.map(group => renderGroup(group))
    }

    function renderUserByInd(userInd, role) {
        if (userInd < users.length) {
            return <React.Fragment key={"renderUserByInd__" + userInd}>
                {renderUser(users[userInd])}<div>{renderPermissionElement(role, true)}</div>
            </React.Fragment>
        }
        prosLogErr("ERR: integrity error renderUserByInd(), customer:", props.customerId, "index:", userInd)
        return ("Virhe - ei käyttäjää indeksille " + userInd)
    }

    function renderGroupByInd(groupInd, role) {
        if (groupInd < groups.length) {
            return <React.Fragment key={"group__" + groupInd}>
                    <div className={"font-400"}>{groups[groupInd].name}</div>
                    <div>{groups[groupInd].members.map((member)=> {return <p key={"member__" + member}>{member}</p>})}</div>
                    <div>{renderPermissionElement(role, true, groups[groupInd].name)}</div>
                </React.Fragment>
        }
        prosLogErr("ERR: integrity error renderGroupByInd(), customer:", props.customerId, "index:", groupInd)
        return ("Virhe - ei ryhmää indeksille " + groupInd)
    }

    function renderUserPermissions(subProject, role) {
        if (subProject.hasOwnProperty("users")) {
            if (subProject.users.hasOwnProperty(role)) {
                return subProject.users[role].map(userInd => renderUserByInd(userInd, role))
            }
        }
    }

    function renderGroupPermissions(subProject, role) {
        if (subProject.hasOwnProperty("groups")) {
            if (subProject.groups.hasOwnProperty(role)) {
                return subProject.groups[role].map(groupInd => renderGroupByInd(groupInd, role))
            }
        }
    }

    function renderSubProject(subProject) {
        let subProjectId = subProject.pid
        let state = subProject[ATTR_OBJ_STATE] === OBJ_STATE_ACT ? null : <span className={"icon-text-set text-sm color-2nd"}>
                            <i className={"ui-icon ui-icon-sm ui-icon-outline-lock ui-icon_color-2nd"} />Arkistoitu
                        </span>
        return <div key={"renderSubProject__" + subProjectId}>
            <h3 className={"element-set valign-center"}>{subProject.name} {state}</h3>
            <div className={"grid-container custom-grid-borders grid-flex-3"}>
                {[ROLE_ADMIN, ROLE_INSPECT, ROLE_REPAIR, ROLE_READER]
                    .map(role => renderUserPermissions(subProject, role))}
                {[ROLE_ADMIN, ROLE_INSPECT, ROLE_REPAIR, ROLE_READER]
                    .map(role => renderGroupPermissions(subProject, role))}
            </div>
        </div>
    }

    function renderProject(project) {
        let note = <p>{project.sub_projects.length} osaprojektia.</p>
        let mainProjectId = project.mpid
        return <div key={'accordion__' + mainProjectId}>
                <AccordionDropdown header={<h4>{project.name}</h4>}>
                    {note}
                    {project.sub_projects.map((subProject, i) => renderSubProject(subProject))}
                </AccordionDropdown>
            </div>
    }

    function renderMainProjects(){
        return projects.map(project => renderProject(project))
    }

    function countPermissionToSubproject(subProject, index, directPermission, role) {
        let userOrGroup = directPermission ? "users": "groups"
        if (subProject.hasOwnProperty(userOrGroup)) {
            if (subProject[userOrGroup].hasOwnProperty(role)) {
                if (subProject[userOrGroup][role].filter(i => i === index).length > 0)
                    return 1
            }
        }
        return 0
    }

    function getUserSubProjects(selectedEmail, directPermission, roles) {
        // returns list of subprojects for which user has either a direct permission or permission via a group
        let searchIndexes
        if (directPermission) {
            let searchIndex = users.findIndex(user => user.email === selectedEmail)
            if (searchIndex < 0) return []
            searchIndexes = [searchIndex]
        } else {
            let searchGroups = groups.filter(group => group.members.includes(selectedEmail))
            searchIndexes = searchGroups.map(group => groups.findIndex(g => g.id === group.id))
        }
        if (searchIndexes.length < 0)
            return []
        let userSubProjects = []
        projects.forEach(mp => userSubProjects = userSubProjects.concat(
            mp.sub_projects.filter( sp => {
                let permissionCount = 0
                for (let i of searchIndexes) {
                    for (let role of roles) {
                        permissionCount += countPermissionToSubproject(sp, i, directPermission, role)
                    }
                }
                return permissionCount > 0
            }))
        )
        return userSubProjects
    }

    function renderNumOfPermissions(selectedEmail, directPermission) {
        const roles = [ROLE_ADMIN, ROLE_INSPECT, ROLE_REPAIR]
        let readerRoleSubProjects = getUserSubProjects(selectedEmail, directPermission, [ROLE_READER])
        let labelPrefix = directPermission ? "Suoraan käyttäjälle" : "Käyttöoikeusryhmän kautta"
        let permList = []
            roles.forEach((role, i)=> {
                const rRole = getUserSubProjects(selectedEmail, directPermission, [role])
                if(rRole.length > 0) permList.push(<p key={role + "__" + i}>{prosConnect.getRoleForUi(role).toLowerCase()}: {rRole.length}</p>)
            })
        return <>
                <h6>{labelPrefix}</h6>
                <p>Lukuoikeuksia: {readerRoleSubProjects.length}</p>
                {permList.length > 0 ? permList : null}
            </>
    }

    function renderMemberInGroups(selectedEmail) {
        let memberInGroups = groups.filter(group => group.members.includes(selectedEmail))
        return <p>{"Kuuluu " + memberInGroups.length + " ryhmään"}</p>
    }

    function getRemoveUserDirectPermissions(selectedEmail) {
        let userSubProjects = getUserSubProjects(selectedEmail, true,
            [ROLE_ADMIN, ROLE_INSPECT, ROLE_REPAIR, ROLE_READER])
        return userSubProjects
            .map(subProject => { return {
                customer_group: props.customerId,
                user_email: selectedEmail,
                pid: subProject.pid,
                user_role: ROLE_NONE}})
    }

    function getRemoveUserPermissionGroupMemberships(selectedEmail) {
        let memberInGroups = groups.filter(group => group.members.includes(selectedEmail))
        return memberInGroups
            .map(group => { return {
                customer_group: props.customerId,
                user_email: selectedEmail,
                pg_name: group.name,
                change: 'remove'
            }})
    }

    function confirmedDelete(selectedEmail) {
        setLoadingNote("Poistetaan käyttöoikeuksia... " + selectedEmail)
        let permissionChanges = getRemoveUserDirectPermissions(selectedEmail)
            .concat(getRemoveUserPermissionGroupMemberships(selectedEmail))
        let cacheId = prosConnect.getUniqueCacheIdWithUserAndDeviceId(props.customerId)
        prosConnect.startLongQuery('removePermsUI', prosConnect.QUERY_CHANGE_PERMS,
            cacheId, userPermissionsRemoved, permissionChanges)
        prosConnect.prosLog("Removing permissions", permissionChanges)
        setCheckEmail('')
    }

    function userPermissionsRemoved() {
        prosConnect.stopLongQuery('removePermsUI')
        startLongQueryToGetPermissions()
    }

    function renderRemovePermissions(selectedEmail) {
        return <ConfirmButton
            btnClass={"2nd"}
            label={"Poista käyttöoikeudet..."}
            icon={"delete"}
            action={()=> {
                confirmedDelete(selectedEmail)
            }}
            confirmAction
            btnType={"fatal"}
        />
    }

    function renderSelectedOneUser(user) {
        return <div key={user.email} className={"inpage-box"}>
                <h3>{user.email + " (" + user.name + ")"}</h3>
                {renderNumOfPermissions(user.email, true)}
                {renderNumOfPermissions(user.email, false)}
                {renderMemberInGroups(user.email)}
                <Spacer/>
                {renderRemovePermissions(user.email)}
            </div>
    }

    function renderSelectedUserPermissions() {
        if (!checkEmail) {
            return null
        }
        let matchingUsers = users.filter(user => prosMultiFilterText(checkEmail, user.email))
        if (matchingUsers.length < 1) {
            return <p>Tarkista email - käyttäjää ei löydy</p>
        }
        if (matchingUsers.length <= UI_LISTED_ELEMENTS_LIMIT) {
            return <div className={"grid-container grid-2 custom-grid"}>{matchingUsers.map(user => renderSelectedOneUser(user))}</div>
        }
        return <p>Hakuehdolla löytyy <strong>{matchingUsers.length}</strong> käyttäjää (Max. {UI_LISTED_ELEMENTS_LIMIT}). Tarkenna hakua.</p>
    }

    function renderPromptUserName() {
        return <>
            <TimerTextInput
                label={"Hae käyttäjää"}
                value={checkEmail}
                placeholder={"Tarkistettavan käyttäjän email"}
                timerCallback={(val) => {
                    setCheckEmail(val)
                }}
                info={"Hae käyttäjän tiedot email-osoitteella"}
            />
            <Spacer/>
            {renderSelectedUserPermissions()}
        </>
    }

    if (loadingNote) {
        return <>
            <div className={"msg msg-inline msg-info"}><p>{loadingNote || 'Toiminto kestää hetken, voit jatkaa työskentelyä ja palata takaisin sivulle myöhemmin.'}</p></div>
            <LoadingAnimation size={"lg"} text={loadingNote}/>
        </>
    }

    return <>
        <h2>Käyttötiedot</h2>
        <div className={"slab width-50_xl"}>
            <h3>Käyttäjän hallinta</h3>
            {renderPromptUserName()}
        </div>
        <Spacer line={true} size={"lg"}/>
        <div className={"slab"}>
            <h3>Käyttäjät</h3>
            <div className={"grid-container grid-1 grid-2_xl"}>
                {renderUsers()}
                <div>{renderCustomer()}</div>
            </div>
        </div>
        <div className={"slab"}>
            <h3>Käyttöoikeusryhmät</h3>
            <div className={"grid-container grid-1 grid-2_xl"}>
                {renderGroups()}
            </div>
        </div>
        <div className={"slab"}>
            <h3>Projektien käyttöoikeudet</h3>
            <div className={"grid-container grid-1 grid-2_xl"}>
                {renderMainProjects()}
            </div>
        </div>
        {/*{renderDeleteConfirmUserPopup()}*/}
    </>
}
